import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={() => changeLanguage('en')}
        className={`transition-all duration-200 transform hover:scale-110 ${
          i18n.language === 'en' ? 'opacity-100 ring-2 ring-white rounded-full' : 'opacity-60 hover:opacity-100'
        }`}
        aria-label="Switch to English"
        title="English"
      >
        <span className="text-2xl">🇺🇸</span>
      </button>
      <button
        onClick={() => changeLanguage('es')}
        className={`transition-all duration-200 transform hover:scale-110 ${
          i18n.language === 'es' ? 'opacity-100 ring-2 ring-white rounded-full' : 'opacity-60 hover:opacity-100'
        }`}
        aria-label="Cambiar a Español"
        title="Español"
      >
        <span className="text-2xl">🇪🇸</span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
